import React from 'react'
import { Container, Row, Button, Col } from "reactstrap";
import Header from 'components/Headers/Header';
import {Link} from 'react-router-dom'

function EventsMedia() {
    const role = JSON.parse(localStorage.getItem("user")).role

  return (
    <>
        {role=="admin" && <Header/>}
        <Container  className="w-auto" fluid>
            <Row className="mt--4 mb-4">
               <Link to={"/" + role + "/events"}>
                <button type="button" className="btn btn-danger mb-2 float-left">
                    Back to Events
                </button>
            </Link> 
            </Row>
            <Row className="mb-4">
                <Col md="6" className="mb-4">
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/LUs2QLT0psQ" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
                <Col md="6">
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/SZYnYjSWNHg" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col md="6" className="mb-4">
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/q421lygp6sQ" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
                <Col md="6">
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/6IV7hW87KGs" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col md="6" className="mb-4">
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/Wj_yq9_Aeg8" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
                <Col md="6">
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/KKaxOlglNSw" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </Col>
            </Row>
        </Container>
      </>
  )
}

export default EventsMedia